
import { Progress } from '@/components/ui/progress';

interface AssessmentProgressProps {
  percentage: number;
  currentCategory?: string;
  currentQuestionIndex?: number;
  totalQuestions?: number;
  completedQuestions?: number;
}

const AssessmentProgress = ({ 
  percentage, 
  currentCategory, 
  currentQuestionIndex,
  totalQuestions,
  completedQuestions = 0
}: AssessmentProgressProps) => {
  return (
    <div className="py-2">
      <div className="mb-2 flex justify-between items-center">
        <div className="text-sm font-medium flex items-center gap-2">
          {currentCategory && (
            <>
              <span className="text-[#e87a2e] font-semibold">{currentCategory}</span>
              {currentQuestionIndex !== undefined && totalQuestions !== undefined && (
                <span className="text-gray-500">
                  Question {currentQuestionIndex + 1} of {totalQuestions}
                  {completedQuestions > 0 && ` (${completedQuestions} completed)`}
                </span>
              )}
            </>
          )}
          {!currentCategory && (
            <span>Assessment Progress</span>
          )}
        </div>
        <div className="text-sm text-muted-foreground">{Math.min(100, percentage)}% Complete</div>
      </div>
      <Progress value={percentage} className="h-2 bg-gray-200" indicatorClassName="bg-[#e87a2e]" />
    </div>
  );
};

export default AssessmentProgress;
